import $ from 'jquery';
import * as TWTmediaQuery from './twt.media-query';

const removeMoreButton = $('.btn.more.show-for-large');
let current = 'only screen and (min-width: 64em)';

window.addEventListener('resize', () => {
  const newSize = TWTmediaQuery.getCurrentSize();

  if (newSize > current) {
    current = newSize;
    removeMoreButton.remove();
  }
});



// WEBPACK FOOTER //
// ./assets/js/components/remove-element.js